import { useNavigate } from "react-router-dom";
import { useState, useContext, useEffect, forwardRef } from "react";
import { GlobalContext } from "../contexts/GlobalContext";

import MuiAlert from "@mui/material/Alert";
import { Snackbar, AlertProps } from "@mui/material";
import { snackBarConfigType } from "../classes/AlertConfig";
import auth, { firestore, USERS_ROOT } from "../services/firebase";
import GoogleIcon from "../assets/icons/google_icon";
import { getRedirectResult } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import User from "../classes/User";

const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
  props,
  ref
) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Login() {
  const navigate = useNavigate();
  const [snackBarConfig, setSnackBarConfig] = useState(snackBarConfigType);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackBarConfig({ open: false, severity: "success", message: "" });
  };

  /*
  useEffect(() => {
    if (getCurrentUser() !== null) {
      // #TODO: Navigate to sell page
      navigate("/home");
    }
    // console.log("Current User: ", getCurrentUser());
  }, [getCurrentUser, navigate]);

  const login = () => {
    try {
      logInWithGoogle()
        .then((res) => {
          setSnackBarConfig({
            open: true,
            severity: "success",
            message: "Mashallah You've Come Back!",
          });
        })
        .catch((error) => {
          setSnackBarConfig({
            open: true,
            severity: "error",
            message: "Login failed!" + error,
          });

          console.log("Error while siging in: ", error);
        });
    } catch (error) {
      setSnackBarConfig({
        open: true,
        severity: "error",
        message: "Login failed!" + error,
      });

      console.log("Error while siging in: ", error);
    }
  };
  */

  const {
    logInWithGoogle,
    logOut,
    currentUser,
    getCurrentUser,
    updateCurrentUser,
  } = useContext(GlobalContext);

  // ✅ Detect user sign-in after redirect
  useEffect(() => {
    const handleAuthStateChange = async () => {
      try {
        const result = await getRedirectResult(auth); // Get user after redirect
        if (result?.user) {
          const user = result.user;
          console.log("User signed in: ", user);

          // Fetch Firestore data or create user
          const userRef = doc(firestore, USERS_ROOT, user.uid);
          const userSnap = await getDoc(userRef);

          if (!userSnap.exists()) {
            const newUser: User = {
              id: user.uid,
              uid: user.uid,
              userName: user.displayName ?? "",
              userId: user.email ?? "",
              email: user.email ?? "",
              mobileNumber: "",
              profilePicUrl: user.photoURL ?? "",
              userType: "",
              createdAt: Date.now(),
              groups: [],
              pendingInvites: [],
            };
            await setDoc(userRef, newUser);
            updateCurrentUser(newUser);
          } else {
            updateCurrentUser(userSnap.data() as User);
          }

          navigate("/home"); // Redirect user after login
        }
      } catch (error) {
        console.error("Error handling redirect:", error);
      }
    };

    handleAuthStateChange();

    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        navigate("/home");
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  const login = async () => {
    try {
      await logInWithGoogle(); // Triggers Google Sign-In via Redirect
    } catch (error) {
      setSnackBarConfig({
        open: true,
        severity: "error",
        message: "Login failed! " + error,
      });
      console.error("Error while signing in:", error);
    }
  };

  return (
    <>
      <div className="bg-custom-gradient h-[100vh] w-full flex flex-col items-center px-6 pb-10">
        <h1 className="font-soria text-[#045B01] text-[4em] text-center mx-8 leading-tight mt-10 flex-1">
          Let's Begin Your Quran Journey
        </h1>

        <button
          className="w-full flex items-center justify-center px-6 py-4 bg-[#3A9437] rounded-full cursor-pointer mb-10"
          type="submit"
          onClick={login}
        >
          <GoogleIcon size={28} className="mr-6" />
          <p className="w-3em font-grgrifter text-[1.5em] tracking-wider text-white text-left">
            Login with Google!
          </p>
        </button>
      </div>

      <Snackbar
        open={snackBarConfig.open}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={2000}
        onClose={handleClose}
      >
        <Alert severity={snackBarConfig.severity} sx={{ width: "80vw" }}>
          {snackBarConfig.message}
        </Alert>
      </Snackbar>
    </>
  );
}

export default Login;
